import * as types from "./premiumSimulatorTypes";

export default function premiumSimulatorReducer(state = {}, action) {
  switch (action.type) {
    case types.SIMULATE: {
      const newData = {
        [action.payload.clientId]: {
          submitting: true,
          parameters: action.payload.parameters,
        },
      };
      return { ...state, ...newData };
    }
    case types.SIMULATE_SUCCESS: {
      const newData = {
        [action.payload.clientId]: {
          ...state[action.payload.clientId],
          results: action.payload.data,
          submitting: false,
        },
      };
      return { ...state, ...newData };
    }
    case types.SIMULATE_FAILURE: {
      const newData = {
        [action.payload.clientId]: {
          ...state[action.payload.clientId],
          error: action.payload.error,
          submitting: false,
        },
      };
      return { ...state, ...newData };
    }
    case types.CLEAR_SIMULATOR: {
      const newData = { [action.payload.clientId]: {} };
      return { ...state, ...newData };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/premiumSimulator/premiumSimulatorReducer.js